import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";

export const selectRowCount = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.rowCount;
};
export const selectJobYear = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.jobYear;
};

export const selectStatus = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.statusSet;
};

export const selectJobMonth = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.jobMonth;
};
export const selectTemplate = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.template;
};
export const selectMapKey = ({ MainReducer }) => {
    return MainReducer.profile.map_api_key;
};
export const selectUsers = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.users;
};
export const selectTemplates = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.templates;
};
export const getRequesting = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.requesting;
};

export const selectSnackbarOpen = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return {
        value: MainReducer.snackbarOpen,
        status: MainReducer.snackbarStatus,
    };
};

export const selectCurrentTable = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.currentTable;
};

export const selectModalOpen = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.modalOpen;
};

export const selectClickedStatusJobID = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.clickedStatusJobID;
};

export const selectPageIndex = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.pageIndex;
};

export const selectSortTableType = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.sortTableType;
};

export const selectSortTableKey = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.sortTableKey;
};

export const selectSortTableAs = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.sortTableAs;
};

export const selectAllJobPacks = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.jobPacks;
};

export const selectAllJobPacks2 = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.jobPacks2;
};

export const selectAllJobPacksModal = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.modalData;
};

export const selectAllJobPacks3 = ({ MainReducer }) => {
    return MainReducer.jobpacks;
};

export const selectDepartments = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.departments;
};
export const selectAreas = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.areas;
};
export const selectDateFrom = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.dateFrom;
};
export const selectDayFrom = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.day;
};
export const selectDateTo = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.dateTo;
};
export const selectFilterStatus = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.filterStatus;
};
export const selectDepartmentStatus = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.departmentType;
};
export const selectAreaStatus = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.areaType;
};
export const selectSearchVal = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.searchVal;
};
export const selectPage = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.page;
};
export const selectRows = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.rows;
};

export const selectJobURN = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.jobUrn;
};

export const selectViewType = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.viewType;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectAreasDept = ({ JobPackManager_reducer }) => {
    const { MainReducer } = JobPackManager_reducer;
    return MainReducer.toggleAreasDept;
};

export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["jobpack"];
        } else return true;
    }
);
export const selectAllJobpacksArray2 = createSelector(
    [selectAllJobPacks3, selectJobMonth, selectJobYear, selectStatus],
    (jobPacks2 = false, month = false, year = false, status = false) => {
        if (jobPacks2) {
            let jobreference = [];
            let finaljob = [];
            Object.values(jobPacks2).map((e) => {
                return Object.values(e).map((f) => {
                    return Object.values(f).map((g) => {
                        return Object.values(g).map((h) => {
                            jobreference.push(h.profile);
                            return null;
                        });
                    });
                });
            });
            jobreference &&
                jobreference.map((e) => {
                    let monthReq;
                    if (month === "jan") {
                        monthReq = "dec";
                    } else if (month === "feb") {
                        monthReq = "jan";
                    } else if (month === "mar") {
                        monthReq = "feb";
                    } else if (month === "apr") {
                        monthReq = "mar";
                    } else if (month === "may") {
                        monthReq = "apr";
                    } else if (month === "jun") {
                        monthReq = "may";
                    } else if (month === "jul") {
                        monthReq = "jun";
                    } else if (month === "aug") {
                        monthReq = "jul";
                    } else if (month === "sep") {
                        monthReq = "aug";
                    } else if (month === "oct") {
                        monthReq = "sep";
                    } else if (month === "nov") {
                        monthReq = "oct";
                    } else {
                        monthReq = "nov";
                    }
                    if (
                        typeof e.deleted === "undefined" ||
                        e.deleted === false
                    ) {
                        if (e.status === status) {
                            // let x = moment("DD/MM/YYYY")
                            let start = moment(e.start_date, "DD-MM-YYYY");
                            let end = moment(e.end_date, "DD-MM-YYYY");
                            let monthReq1 = moment()
                                .year(year)
                                .month(monthReq)
                                .date(31);
                            let monthReq2 = moment()
                                .year(year)
                                .month(monthReq)
                                .date(30);
                            let startmonth = moment()
                                .year(year)
                                .month(month)
                                .startOf("month");
                            let endmonth = moment()
                                .year(year)
                                .month(month)
                                .endOf("month");
                            if (
                                startmonth.isBetween(start, end, null, "[]") ||
                                endmonth.isBetween(start, end, null, "[]") ||
                                start.isBetween(
                                    startmonth,
                                    endmonth,
                                    null,
                                    "[]"
                                ) ||
                                end.isBetween(
                                    startmonth,
                                    endmonth,
                                    null,
                                    "[]"
                                ) ||
                                end.isBetween(
                                    monthReq1,
                                    endmonth,
                                    null,
                                    "[]"
                                ) ||
                                end.isBetween(monthReq2, endmonth, null, "[]")
                            ) {
                                let year = moment(
                                    e.timestamp,
                                    "DD-MM-YYYY HH:mm:ss"
                                ).format("YYYY");
                                let month = moment(
                                    e.timestamp,
                                    "DD-MM-YYYY HH:mm:ss"
                                )
                                    .format("MMM")
                                    .toLowerCase();
                                e[
                                    "view_route"
                                ] = `/job-pack-view/jobpacks/${e.status}/${year}/${month}/${e.job_id}`;
                                e[
                                    "edit_route"
                                ] = `/job-pack-edit/jobpacks/${e.status}/${year}/${month}/${e.job_id}`;
                                finaljob.push(e);
                            }
                        }
                    }
                    return null;
                });
            return finaljob;
        } else return false;
    }
);

export const selectArchieveJobList = createSelector(
    [selectAllJobPacks3],
    (jobs = false) => {
        if (jobs) {
            let jobreference = [];
            let archieveJobIds = [];
            Object.values(jobs.active).map((e) => {
                Object.values(e).map((f) => {
                    Object.values(f).map((g) => {
                        jobreference.push(g.profile);
                        return null;
                    });
                    return null;
                });
                return null;
            });
            let lastWeeksStartDate = moment()
                .subtract(1, "weeks")
                .startOf("isoWeek")
                .format("DD-MM-YYYY");
            jobreference &&
                jobreference.map((e) => {
                    if (
                        typeof e.deleted === "undefined" ||
                        e.deleted === false
                    ) {
                        if (
                            typeof e.prevent_archive !== "undefined" &&
                            e.prevent_archive === "No"
                        ) {
                            let end = moment(e.end_date, "DD-MM-YYYY");
                            let compareDate = moment(
                                lastWeeksStartDate,
                                "DD-MM-YYYY"
                            );
                            if (end.isBefore(compareDate)) {
                                archieveJobIds.push(e.job_id);
                            }
                        } else {
                            return null;
                        }
                    }
                    return null;
                });
            return archieveJobIds;
        }
        return false;
    }
);

export const selectAllJobpacksArray = createSelector(
    [selectAllJobPacks],
    (jobPacks = false) => {
        if (jobPacks) {
            const jobpackArray = _.compact(
                Object.keys(jobPacks).map((jpKey) => {
                    const jp = jobPacks[jpKey];
                    let profile = _.get(jp, "profile");

                    profile =
                        profile &&
                        Object.keys(profile).reduce((acc, curr) => {
                            acc[curr] = _.get(profile, `${curr}`) || "N/A";
                            return acc;
                        }, {});
                    if (profile.deleted) return null;
                    else
                        return {
                            key: jpKey,
                            ...profile,
                        };
                })
            );
            return jobpackArray;
        } else return false;
    }
);

export const selectFilteredJobpacks = createSelector(
    [
        selectAllJobpacksArray2,
        selectDateFrom,
        selectDateTo,
        //    selectFilterStatus,
        selectSearchVal,
        selectSortTableType,
        selectSortTableKey,
        selectSortTableAs,
        selectProfile,
        selectDayFrom,
        selectTemplate,
        selectJobURN
    ],
    (
        jobpacksArray = false,
        dateFrom = false,
        dateTo = false,
        //   filterStatus = "all",

        searchVal = "",
        sortType,
        sortKey,
        sortAs,
        { departments = false, areas = false },
        day = false,
        template,
        jobUrn
    ) => {
        if (Array.isArray(jobpacksArray) === false) {
            return [];
        }
        if (!dateTo) {
            dateTo = dateFrom;
        }
        let result = JSON.parse(JSON.stringify(jobpacksArray));
        if (dateFrom) {
            let dt = moment(dateTo).endOf("day");
            let df = moment(dateFrom).startOf("day");
            result = result.filter((jp) => {
                let rd = moment(jp.start_date, "DD-MM-YYYY");
                if (rd.isBetween(df, dt, null, "[]")) {
                    return jp;
                } else return null;
            });
        }

        if (departments) {
            result = result.filter((jp) => {
                if (jp.departments && jp.departments !== "N/A") {
                    let flag = false;
                    departments.map((f) => {
                        if (f === jp.departments) {
                            flag = true;
                        }
                        return null;
                    });
                    return flag;
                } else {
                    return true;
                }
            });
        }

        if (areas) {
            result = result.filter((jp) => {
                if (jp.areas && jp.areas !== "N/A") {
                    let flag = false;
                    areas.map((f) => {
                        if (f === jp.areas) {
                            flag = true;
                        }
                        return null;
                    });
                    return flag;
                } else {
                    return true;
                }
            });
        }

        if (searchVal !== "") {
            const sv = searchVal.toLowerCase();
            result = result.filter((jp) => {
                let key = jp.job_id ? jp.job_id.toLowerCase() : "";
                let job_name = jp.job_name ? jp.job_name.toLowerCase() : "";
                let address = jp.address ? jp.address.toLowerCase() : "";
                return (
                    key.includes(sv) ||
                    job_name.includes(sv) ||
                    address.includes(sv)
                );
            });
        }

        

        if (day) {
            result = result.filter((e) => {
                let x = moment(e.timestamp).format("MM-DD-YYYY");
                let y = moment(day).format("DD-MM-YYYY");
                return moment(x).isSame(y);
            });
        }
        if(template) {
            result = result.filter((e) => e.job_type === template)
        }

        if (jobUrn !== "") {
            const urn = jobUrn.toLowerCase();
            result = result.filter((jp) => {
                let key = jp.urn ? jp.urn.toLowerCase() : "";
               
                return (
                    key.includes(urn) 
                );
            });
        }

        if (sortKey !== false && sortAs !== false) {
            switch (sortAs) {
                case "string": {
                    result = result.sort((a, b) => {
                        return a[sortKey]
                            .toLowerCase()
                            .trim()
                            .localeCompare(b[sortKey].toLowerCase().trim());
                    });

                    break;
                }
                case "date": {
                    result = result.sort((a, b) => {
                        return (
                            moment(a[sortKey], "DD-MM-YYYY") -
                            moment(b[sortKey], "DD-MM-YYYY")
                        );
                    });

                    break;
                }
                case "timestamp": {
                    result = result.sort((a, b) => {
                        return (
                            moment(a[sortKey], "DD-MM-YYYY HH:mm:ss") -
                            moment(b[sortKey], "DD-MM-YYYY HH:mm:ss")
                        );
                    });
                    break;
                }
                default: {
                    break;
                }
            }
        }
        if (sortType === "asc") {
            result = result.reverse();
        }
        return [...result];
    }
);

export const selectPaginatedJobpacks = createSelector(
    [selectFilteredJobpacks, selectRowCount, selectPageIndex],
    (filteredJobpacks, rowCount, pageIndex) => {
        const start = rowCount * pageIndex;
        const end = start + rowCount;
        const result = filteredJobpacks.slice(start, end);
        return result;
    }
);

export const selectJobModalData = createSelector(
    [selectClickedStatusJobID, selectAllJobPacksModal],
    (id, allJobpacks) => {
        return { key: id, ..._.get(allJobpacks, `${id}.profile`) };
    }
);

export const selectJobReportModalData = createSelector(
    [selectClickedStatusJobID, selectAllJobPacksModal],
    (id, allJobpacks) => {
        return { ..._.get(allJobpacks, `${id}.reports`) };
    }
);

export const selectSpeUsers = createSelector([selectUsers], (users = false) => {
    if (users) {
        let userList = {};
        Object.keys(users).map((user) => {
            let profile = _.get(users[user], "profile") || false;
            let { email = false, uid = false } = profile;
            userList = _.assign(userList, { [email]: uid });

            return null;
        });
        return userList;
    } else {
        return false;
    }
});
